export default {"src":"/_next/static/media/face-id.cbe2e159.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};